module.exports = __webpack_public_path__ + "img/icon8.65267edf.png";